import { useCallback, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";

const reconcileOrder = (savedOrder, ids) => {
	const known = (Array.isArray(savedOrder) ? savedOrder : []).filter((id) =>
		ids.includes(id),
	);
	const missing = ids.filter((id) => !known.includes(id));
	return [...known, ...missing];
};

export const useSectionOrder = (storageKey, ids) => {
	const [savedOrder, setSavedOrder] = useLocalStorage(storageKey, []);

	const order = useMemo(
		() => reconcileOrder(savedOrder, ids),
		[savedOrder, ids],
	);

	const moveSection = useCallback(
		(dragId, targetId, edge = "before") => {
			if (!dragId || !targetId || dragId === targetId) return;

			setSavedOrder((prev) => {
				const base = reconcileOrder(prev, ids);
				const withoutDrag = base.filter((id) => id !== dragId);
				let targetIndex = withoutDrag.indexOf(targetId);

				if (targetIndex === -1) {
					return [...withoutDrag, dragId];
				}

				if (edge === "after") targetIndex += 1;
				withoutDrag.splice(targetIndex, 0, dragId);
				return withoutDrag;
			});
		},
		[ids, setSavedOrder],
	);

	return { order, moveSection };
};
